import { useLazyQuery } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { SEARCH_PACKAGE_BY_CRUISE } from '../queries';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return { searchPackageCodeByCruiseInfo: bffResponse?.packageCode ?? null };
}

export default function useCruisePackageCode(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useLazyQuery(SEARCH_PACKAGE_BY_CRUISE, options);
  const [restExecute, restState] = useAsyncCall(
    ({ variables: { sailDate, shipCode } = {} } = {}) =>
      restRequest({
        path: '/air-api/v1/cruises/package-code',
        params: { sailDate, shipCode },
      }).then(toGraphqlShape),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
